import { useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { hrefFor } from '../../routers';
import { PaymentSource } from '../../constants';
import { reportError } from '../../lib/reportError';
import {
  useUpdateCartMutation,
  CartUpdateAction,
  CartUpdatePropertyName
} from '../../hooks/useCart';
import { useErrorModal } from '../../hooks/useErrorModal';

export const useChangePaymentSource = () => {
  const location = useLocation();
  const history = useHistory();

  const [updateCart] = useUpdateCartMutation();
  const { showErrorModal } = useErrorModal();

  const changePaymentSource = useCallback(
    async (paymentSource: PaymentSource, cartId?: string) => {
      try {
        await updateCart(CartUpdateAction.PaymentSource, {
          id: cartId,
          [CartUpdatePropertyName.PaymentSource]: paymentSource
        });

        if (location.pathname !== hrefFor.CheckoutPage()) {
          history.push(hrefFor.CheckoutPage());
        }
      } catch (error) {
        reportError(error);
        showErrorModal();
      }
    },
    [updateCart, history, showErrorModal, location.pathname]
  );

  return changePaymentSource;
};
